import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import {Autocomplete, TextField }  from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useHistory } from "react-router-dom";
import { Checkbox } from '@material-ui/core';

//For everyone playing along at home, this uses some different components than our other modals,
//but I kinda like this one.  Let's give a thumbs up/down to the different approaches and then
//come back and refactor for consistency

export default function FormDialog(props) {
    const [open, setOpen] = useState(false);
    const [name, setName] = useState();
    const [address, setAddress] = useState();
    const [type, setType] = useState();
    const [units, setUnits] = useState();
    const [is_graphed, setIsGraphed] = useState();
    const [is_active, setIsActive] = useState();

    useEffect(() => {
        if (props.selectedPoint) {
            setName(props.selectedPoint.name)
            setAddress(props.selectedPoint.address)
            setType(props.selectedPoint.type)
            setUnits(props.selectedPoint.units)
            setIsGraphed(props.selectedPoint.is_graphed)
            setIsActive(props.selectedPoint.is_active)
        } else {
            setName(null)
            setAddress(null)
            setType(null)
            setUnits(null)
            setIsGraphed(null)
            setIsActive(null)
        }
    }, [props.selectedPoint])

    useEffect(() => {
        setOpen(props.open)
    }, [props.open])

    const handleClose = () => {
        props.closeCallback();
    };

    const handleSubmit = () => {
        let point = { 
            point_id: props.selectedPoint ? props.selectedPoint.point_id : null,
            name: name,
            address: address,
            equipment_id: props.equipmentId,
            type: type,
            units: units,
            is_graphed: is_graphed,
            is_active: is_active
        }; 

        props.addOrUpdatePointCallback(point).then(() => {
            props.closeCallback();
        })
    }

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{props.selectedPoint ? "Update Equipment Point" : "Add Equipment Point"}</DialogTitle>
            <DialogContent>
                <div className="row-form-field">
                    <TextField id="name" label="Point Name" variant="outlined" size="small" value={name || ''} fullWidth onChange={(e) => setName(e.target.value)} />
                </div>
                <div className="row-form-field">
                    <TextField id="address" label="Path to Field" variant="outlined" size="small" value={address || ''} fullWidth onChange={(e) => setAddress(e.target.value)} />
                </div>
                <div className="row-form-field">
                {
                    props.brickTypes ?
                    <Autocomplete
                        id="types"
                        options={props.brickTypes || []}
                        value={props.brickTypes.find(t => t.brick_point_type === type)}
                        getOptionLabel={option => option.name}
                        groupBy={(option) => option.parent}
                        renderInput={(params) => <TextField {...params} label="Point Type" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setType(newValue.brick_point_type);
                        }}
                    />
                    : null
                } 
                </div>
                <div className="row-form-field">
                {
                    props.allUnits ?
                    <Autocomplete
                        id="units"
                        options={props.allUnits || []}
                        value={props.allUnits.find(u => u.brick_unit === units)}
                        getOptionLabel={option => option.name}
                        renderInput={(params) => <TextField {...params} label="Units" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setUnits(newValue.brick_unit);
                        }}
                    />
                    : null
                } 
                </div>
                <div className="row-form-field">
                {
                    <label>
                        Graphed
                        <Checkbox
                        variant="contained"
                        color="primary"
                        aria-label={"Is Graphed"}
                        size={"small"}
                        defaultChecked={is_graphed}
                        onChange={(event,newValue) => {
                            setIsGraphed(!is_graphed)
                        }}
                        >
                        </Checkbox>
                    </label>
                }
                {
                    <label>
                        Active
                        <Checkbox
                        variant="contained"
                        color="primary"
                        aria-label={"Is Active"}
                        size={"small"}
                        defaultChecked={is_active}
                        onChange={(event,newValue) => {
                            setIsActive(!is_active)
                        }}
                        >
                        </Checkbox>
                    </label>
                } 
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSubmit}>Submit</Button>
            </DialogActions>
        </Dialog>
    )
}